import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@mui/material";
// import { toast } from 'react-hot-toast';
import {
  ArrowDownTrayIcon
} from "@heroicons/react/24/solid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import { ModalShareProfile } from "../../../../components/ModalShareProfile";
import { ModalSheetChoice } from "./ModalSheetChoice/ModalSheetChoice";
import { ModalSheetShareProfile } from "./ModalSheetShareProfile/ModalSheetShareProfile";
import { ImageComponent } from "./ImageComponent";
import { useMediaQuery } from "react-responsive";
import JSZip from "jszip";
import { saveAs } from "file-saver";

import styles from "./styles.module.css";
import { isDicomTypeUtils } from "../../../../utils/fileTypes/isDicomTypeUtils";
import { is3dTypeUtils } from "../../../../utils/fileTypes/is3dTypeUtils";

export function Imagens({
  imagensPaciente,
  PatientNameAndId,
  dataAtendimento,
  imagemPerfil,
  loadingImagens,
  isShare,
  seqAtend,
  idClient,
  namePacient
}: any) {
  const location = useLocation();

  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [selectedImages, setSelectedImages] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const isMobileScreen = useMediaQuery({ query: "(max-width: 684px)" });
  const [isModalSheetChoiceOpen, setModalSheetChoiceOpen] = useState(false);
  const [isModalSheetShareProfileOpen, setModalSheetShareProfileOpen] =
    useState(false);

  const showAddButton = selectedImages?.length > 0;

  const handleSelectAllImages = () => {
    if (selectAll) {
      setSelectedImages([]);
    } else {
      const allImages = imagensPaciente?.map((image: any) => ({
        link: image.link,
        nome: image.nome,
        complemento: image.complemento,
        tamanho: image.tamanho
      }));
      setSelectedImages(allImages);
    }
    setSelectAll((prevSelectAll) => !prevSelectAll);
  };

  const handleImageClick = (imageLink: string, imageName: string, imageComplemento: string, imageLinkDownload: any, tamanho: number) => {
    setSelectedImages((prevSelected: any) => {
      if (
        prevSelected.some(
          (selectedImage: any) => selectedImage.link === imageLink
        )
      ) {
        return prevSelected?.filter(
          (selectedImage: any) => selectedImage.link !== imageLink
        );
      } else {
        return [...prevSelected, { link: imageLink, nome: imageName, complemento: imageComplemento, idClient: idClient, seqAtend: seqAtend, linkDownload: imageLinkDownload, tamanho: tamanho }];
      }
    });
  };

  const handleOPenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModalSheetChoice = () => {
    if (isMobileScreen && selectedImages.length >= 1) {
      setModalSheetChoiceOpen(true);
    }
  };

  const handleCloseModalSheetChoice = () => {
    setModalSheetChoiceOpen(false);
  };

  const handleOpenModalSheetShareProfile = () => {
    setModalSheetShareProfileOpen(true);
  };

  const handleCloseModalSheetShareProfile = () => {
    setModalSheetShareProfileOpen(false);
  };

  const zip = new JSZip();
  const promises = [];

  function getExtensionFromLink(link) {
    const parts = link.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
    }
    return null;
  }

  const handleDownloadClick = () => {
    if (selectedImages?.length === 0) {
      alert("Nenhuma imagem selecionada.");
      return;
    }

    setLoadingNextPage(true);
    const firstName = namePacient.split(" ")[0];
    const zipFileName = `${firstName}_imagens.zip`;

    if (selectedImages.length === 1) {
      const image = selectedImages[0];

      if (isDicomTypeUtils(image.complemento) || is3dTypeUtils(image.complemento)) {
        const link = document.createElement('a');
        link.href = image.linkDownload || image.link;
        link.setAttribute('download', `${image.nome}${image.complemento}`); 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Download iniciado!', { autoClose: 2000 });
        setLoadingNextPage(false);
      } else {
        toast.promise(
          fetch(image.linkDownload || image.link)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Erro ao baixar arquivo: ${response.statusText}`);
              }
              return response.blob();
            })
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const tempLink = document.createElement('a');
              tempLink.href = url;
              tempLink.download = `${image.nome}${image.complemento}`; 
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              window.URL.revokeObjectURL(url);
            })
            .finally(() => {
              setLoadingNextPage(false);
            }),
          {
            pending: 'Baixando arquivo...',
            success: 'Arquivo baixado com sucesso!',
            error: 'Erro ao baixar o arquivo.',
          }
        );
      }
    } else {
      const zip = new JSZip();
      const downloadPromises = selectedImages.map((image) => {
        return fetch(image.linkDownload || image.link)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Erro ao baixar arquivo: ${response.statusText}`);
            }
            return response.blob();
          })
          .then((blob) => {
            zip.file(`${image.nome}${image.complemento}`, blob);
          })
          .catch((error) => {
            console.error("Erro ao baixar arquivo:", error);
            throw error;
          });
      });

      toast.promise(
        Promise.all(downloadPromises)
          .then(() => {
            return zip.generateAsync({ type: "blob" }); 
          })
          .then((content) => {
            saveAs(content, zipFileName);
          })
          .finally(() => {
            setLoadingNextPage(false);
          }),
        {
          pending: 'Baixando arquivos...',
          success: 'Arquivos baixados com sucesso!',
          error: 'Erro ao baixar os arquivos.',
        }
      );
    }
  };

  useEffect(() => {
    if (location.pathname.includes("/dashboard/perfil-paciente/")) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className={styles.wrapper}>
      {imagensPaciente?.length == 0 ? (
        <div
          style={{
            textAlign: "center",
            paddingTop: "40px",
            color: "#afafaf",
            fontWeight: 500
          }}
        >
          <p>Sem imagens no momento.</p>
        </div>
      ) : (
        <>
          <div className={styles.containerTop}>
            <div className={styles.container_inputSelectAll}>
              <input
                className={styles.inputSelectAll}
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllImages}
              />
              <span>Selecionar todas</span>
            </div>

            <div className={styles.containerButtons}>
              {showAddButton && (
                <div className={`${styles.containerButtons_select_show}`}>

                  <div className={styles.containerButton_download}>
                    <Button
                      onClick={handleDownloadClick}
                      disabled={loadingNextPage}
                      className={`${styles.buttonDownload} 
                          ${isMobileScreen
                          ? styles.buttonMobile
                          : ""
                        }`}
                      style={{
                        cursor: loadingNextPage ? 'not-allowed' : 'pointer'
                      }}
                    >
                      <ArrowDownTrayIcon width={20} height={20} />
                      {" "}
                      {!isMobileScreen &&
                        (loadingNextPage ? "Carregando" : "Baixar")}
                      { }
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={styles.wrapperImg}>
            <div className={styles.wrapper_imagens}>
              {imagensPaciente?.map((image: any, imageIndex: number) =>
                !image.link.endsWith(".pdf") &&
                  !image.complemento.endsWith(".rar") &&
                  !(image.complemento.endsWith(".zip") && idClient == 15831)  && // Responsavel por ocultar arquivos zip no Sesc na aba de Imagens
                  (!isMobileScreen || (!image.complemento.endsWith(".dfx"))) ? (
                  <ImageComponent
                    key={imageIndex}
                    image={image}
                    selected={selectedImages.some(
                      (selectedImage) => selectedImage.link === image.link
                    )}
                    handleImageClick={handleImageClick}
                    imageTitle={image.nome}
                    imageDate={dataAtendimento}
                    handleOpenModalSheetChoice={handleOpenModalSheetChoice}
                    imagensPaciente={imagensPaciente}
                    isShare={isShare}
                    showAddButton={showAddButton}
                  />
                ) : null
              )}
            </div>
          </div>
        </>
      )}

      {isModalOpen && (
        <ModalShareProfile
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          selectedImages={selectedImages}
          PatientNameAndId={PatientNameAndId}
        />
      )}
      {isModalSheetChoiceOpen && (
        <ModalSheetChoice
          isOpen={isModalSheetChoiceOpen}
          onRequestClose={handleCloseModalSheetChoice}
          handleOpenModalSheetShareProfile={handleOpenModalSheetShareProfile}
          image={selectedImages}
        />
      )}
      {isModalSheetShareProfileOpen && (
        <ModalSheetShareProfile
          isOpen={isModalSheetShareProfileOpen}
          onRequestClose={handleCloseModalSheetShareProfile}
          selectedImages={selectedImages}
          PatientImageSource={imagemPerfil}
          PatientNameAndId={PatientNameAndId}
        />
      )}
    </div>
  );
}
